import CustomLink from "./custom-link.component";

export default CustomLink;
